<!-- /src/views/Sessions.vue -->
<template>
  <LayoutFullWidth class="landing--page">
    <template v-slot:header>
      <h1 id="page-header" class="page-header">Content</h1>
          <div class="card-grid-header__actions button__group">
            <button
              class="filter--trigger button button--gray button--sm"
              @click="toggleFilters()"
            ><span v-if="activeQueries.length > 0">Modify Filtered Results</span>
            <span v-else>Filter Results</span></button>
            <Sort />
          </div>
    </template>
    <template v-slot:content>
      <div class="main-content">
        <div class="filter-panel"
          v-show="showFilters"
        >
          <Filters :postType="sessionType" />
          <button
            class="button button--gray button--medium button--accent"
            @click="toggleFilters()"
          >Close Filter Panel</button>
        </div>
        <header class="card-grid-header">
          <ActiveQueries />
        </header>
        <Loader v-if="isLoading" color="gray" />
        <NoResults v-else-if="noCards">
          <h2>Whoops! Looks like we do not have content related to your query.</h2>
          If you think this topic would be helpful to others, please consider using the "Need Help?" feature in the upper right.
        </NoResults>
        <CardGrid v-else="pageCards.length > 0" :cards="pageCards" />
        <Pagination v-if="totalPages > 1" :page="page" :total="totalPages" />
      </div>
    </template>
  </LayoutFullWidth>
</template>

<script>
import LayoutFullWidth from '@/components/layouts/FullWidth'
import CardGrid from '@/components/common/Card/CardGrid'
import Sort from '@/components/common/Sort'
import Filters from '@/components/common/Sidebar/Filters'
import ActiveQueries from '@/components/common/Search/ActiveQueries'
import Pagination from '@/components/common/Pagination'
import searchMixin from '@/mixins/searchMixin'
import _omit from 'lodash/omit'
import _values from 'lodash/values'
import _each from 'lodash/each'
import _isNaN from 'lodash/isNaN'
import _pick from 'lodash/pick'
import _keys from 'lodash/keys'
import Loader from '@/components/common/Loaders/Loader'
import NoResults from '@/components/common/Loaders/NoResults'

export default {
  name: 'sessions',
  data() {
    return {
      cardCount: 0,
      noCards: false,
      sessionType: 'sessions',
      postType: 'sessions',
      showFilters: false,
    }
  },

  computed: {
    page() {
      const { page } = Object.create(this.$route.query)
      return typeof page != 'undefined' ? page : 1
    },

    type() {
      return this.$store.getters['posts/getTypeInfo'](this.sessionType)
    },
    // defines the cards displayed on page
    cards() {
      let cards = this.$store.getters['posts/getAll'](this.sessionType)
      // the order of these functions is important since sorting needs to happen after input search
      // cards = this.searchViaInput(cards)
      cards = this.filterCards(cards)
      // if (cards.length == 0) {
      //   this.checkCards()
      // }

      return cards
    },

    isLoading() {
      return !this.$store.getters['posts/postResultsLoaded']('sessions')
    },

    pageCards() {
      return this.cards
    },

    itemsPerPage() {
      return this.$store.getters['posts/getItemsPerPage'](this.sessionType)
    },

    totalPages() {
      return this.$store.getters['posts/getTotalPages'](this.sessionType)
    },
    manditory() {
      const { userCompleted, userDivisions, userGroups, containsId } = this
      const completed = userCompleted ? userCompleted.map(div => div.id) : []
      const divisions = userDivisions
        ? userDivisions.map(div => div.term_id)
        : []
      const groups = userGroups ? userGroups.map(group => group.term_id) : []
      return this.$store.getters['posts/getAllManditoryPosts'].filter(item => {
        // if completed then return false
        if (completed.length > 0 && completed.includes(item.id)) return false
        const { user_divisions_required, user_groups_required } = item.acf
        // on additional setting manditory for everyone
        if (!user_divisions_required && !user_groups_required) return true
        // check if groups in item and groups in user have match
        if (
          user_groups_required &&
          groups.length > 0 &&
          user_groups_required.length > 0 &&
          containsId(user_groups_required, groups).length > 0
        )
          return true
        // check if divisions in item and divisions in user have match
        if (
          user_divisions_required &&
          completed.length > 0 &&
          user_divisions_required.length > 0 &&
          containsId(user_divisions_required, divisions).length > 0
        )
          return true
        // return false if no other matches
        return false
      })
    },
  },

  watch: {
    cards(newCards) {
      this.noCards = newCards.length == 0
      return newCards
    },
  },

  methods: {
    checkCards() {
      setTimeout(() => {
        if (this.cards.length == 0) this.noCards = true
      }, 5000)
    },

    removeFilterItem(queryItem) {
      let { query, name } = this.$route
      query = _omit(query, _keys(queryItem))
      this.$router.push({
        name,
        query,
      })
    },

    getSessionType() {
      return this.$route.params.sessionType
    },

    toggleFilters() {
      this.showFilters = !this.showFilters
    },

    initialCaps(string) {
      return string.split(' ').map(word => {
        return word[0].toUpperCase() + word.substr(1)
      }).join(' ')
    },

    containsId(arr1, arr2) {
      var ret = []
      arr1.sort()
      arr2.sort()
      for (var i = 0; i < arr1.length; i += 1) {
        if (arr2.indexOf(arr1[i]) > -1) {
          ret.push(arr1[i])
        }
      }
      return ret
    },
  },

  mounted() {
    this.checkCards()
    // this.cards = this.getCards()
    this.$store.dispatch('updatePageTitle', 'Sessions')
  },

  beforeMount() {
    // console.log(this.$route)
    // this.$store.dispatch('posts/getAll')
  },

  mixins: [searchMixin],

  components: {
    LayoutFullWidth,
    CardGrid,
    Pagination,
    Filters,
    Sort,
    ActiveQueries,
    Loader,
    NoResults,
  },
}
</script>

<style scoped>
.card-grid-header {
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto;
  margin-bottom: 1rem;

  h2 {
    margin-bottom: 0;
  }

  &__actions {
    font-size: 0.7em;
    justify-self: start;
    grid-template-columns: 1fr;
    display: grid;
    @media(--tablet) {
      display: flex;
      /* grid */
    }
  }
}

.filter-panel {
  display: grid;
  margin-bottom: 1rem;
  padding: 1rem;
  gap: 1rem;
  background-color: rgba(var(--gray-RGB), .3);
  border-radius: 4px;

  &> button {
    justify-self: end;
    font-size: .6rem;
    padding: .35rem .5rem;
  }
}

.form__control {
  margin: 0;
}

</style>
